<template>
  <div class="container">


    <!-- 动态表单列表 -->
    <div class="form-container">
      <div class="title">球杆登记</div>
      <div
          class="form-item-wrapper"
          v-for="(form, index) in formList"
          :key="index"
      >
        <!-- 条目标题 + 删除按钮 -->
        <div class="form-item-header">
          <span>球杆 {{ index + 1 }}</span>
          <el-button
              type="text"
              class="delete-btn"
              @click="deleteFormItem(index)"
              :disabled="formList.length <= 1"
          >
            <i class="el-icon-delete"></i> 删除
          </el-button>
        </div>

        <el-form class="form-inline" :model="form">
          <!-- 球杆编号 -->
          <el-form-item label="球杆编号：" prop="number">
            <el-input
                v-model="form.number"
                placeholder="请输入球杆编号"
            ></el-input>
          </el-form-item>

          <!-- 球杆品牌 -->
          <el-form-item label="球杆品牌：" prop="brand">
            <el-input
                type="text"
                v-model="form.brand"
                placeholder="请选择球杆品牌"
                @keydown.prevent
                @click.native="openSelectDialog(index)"
                readonly
            ></el-input>
          </el-form-item>

          <!-- 型号 -->
          <el-form-item label="球杆型号：" prop="model">
            <el-input
                v-model="form.model"
                placeholder="请输入球杆型号"
                @keydown.prevent
                @click.native="openModelSelectDialog(index)"
                readonly
            ></el-input>
          </el-form-item>

          <!-- 购买渠道 -->
          <el-form-item label="购买渠道：" prop="channel">
            <el-input
                v-model="form.channel"
                placeholder="请输入购买渠道"
            ></el-input>
          </el-form-item>

          <!-- 购买价格 -->
          <el-form-item label="购买价格：" prop="price">
            <el-input
                v-model="form.price"
                placeholder="请输入购买价格"
            ></el-input>
          </el-form-item>

          <el-form-item label="购买时间：" prop="startTime">
            <input
                type="text"
                class="uni-date-input"
                v-model="form.startTime"
                placeholder="点击选择购买日期"
                @click="openDateDrawer(index)"
                readonly
            >
          </el-form-item>


          <el-form-item label="购买凭证：" prop="proof">
            <el-upload
                class="avatar-uploader"
                action="#"
                accept="image/*"
                :capture="captureType"
                :on-change="(file, fileList) => handleFileChange(file, fileList, index)"
                :file-list="form.fileList"
                list-type="picture-card"
                :on-preview="(file) => handlePreview(file, index)"
                :on-remove="(file, fileList) => handleRemove(file, fileList, index)"
                :limit="3"
                :on-exceed="() => handleExceed(index)"
                multiple
                :auto-upload="false"
            >
              <i class="el-icon-plus" />
            </el-upload>
            <div class="upload-tip">最多上传3张图片，支持jpg/png格式，可多选</div>
            <!-- 图片预览弹窗 -->
            <el-dialog :visible.sync="dialogVisible" title="图片预览" width="90%" append-to-body>
              <img
                  :src="dialogImageUrl"
                  alt="预览图"
                  style="width: 100%; max-height: 80vh; object-fit: contain;"
                  @error="handleImageError"
              />
              <div v-if="!dialogImageUrl" class="preview-empty">暂无预览图片</div>
            </el-dialog>
          </el-form-item>

        </el-form>
      </div>
    </div>

    <!-- 调用提示语弹框组件 -->
    <MessageDialog
        v-if="showDialog"
        :title="dialogTitle"
        :content="messageContent"
        :confirmText="confirmText"
        :showCancel="showCancel"
        @confirm="handleDialogConfirm"
        @cancel="handleCancel"
        @close="showDialog = false"
        closeOnMask
    />

    <!-- 引入自定义select组件 -->
    <SelectDialog
        :visible="selectDialogVisible"
        :options="selectOptions"
        :active-value="currentFormIndex !== -1 ? formList[currentFormIndex].brand : ''"
        @select="handleSelect"
        @close="selectDialogVisible = false"
    />

    <!--  型号select组件  -->
    <SelectDialog
        :visible="selectModelDialogVisible"
        :options="selectOptions"
        :active-value="currentFormIndex !== -1 ? formList[currentFormIndex].model : ''"
        @select="handleSelectModel"
        @close="selectModelDialogVisible = false"
    />

    <!-- 引入自定义日期抽屉组件 -->
    <DatePickerDrawer
        :visible="dateDrawerVisible"
        :init-date="currentDateRowIndex !== -1 ? formList[currentDateRowIndex].startTime : ''"
        @confirm="handleDateConfirm"
        @close="dateDrawerVisible = false"
    />

    <!-- 添加球杆按钮 -->
    <div class="btn-group-back">
      <el-button type="default" @click="addFormItem">
        <i class="el-icon-plus"></i> 批量添加球杆
      </el-button>
    </div>

    <div class="btn-group">
      <el-button type="primary" @click="handleSubmit">登记</el-button>
    </div>
    <div class="btn-group-back">
      <el-button type="default" @click="goHome">返回首页</el-button>
    </div>
    <el-footer class="s-footer">
      <p>JING-DIAN BILLIARD CLUB AFTER SALES</p>
    </el-footer>
  </div>
</template>

<script>
import MessageDialog from "@/views/business/utils/messageDialog.vue";
import {brandDropDown, relation} from "@/api/sales";
import SelectDialog from "@/views/business/utils/selectDialog.vue";
import DatePickerDrawer from "@/views/business/utils/datePickerDrawer.vue";

export default {
  components: {
    MessageDialog,
    SelectDialog,
    DatePickerDrawer
  },
  data() {
    return {
      // 动态表单列表（每条元素对应一条球杆信息）
      formList: [
        {
          number: '',         // 球杆编号
          brand: '',          // 球杆品牌（下拉选择值）
          brandCode: '',          // 球杆品牌（下拉选择值）
          model: '',          // 球杆型号
          modelCode: '',
          channel: '',        // 购买渠道
          price: '',          // 购买价格
          startTime: '',      // 购买时间（格式：yyyy-MM-dd）
          proof: [],          // 购买凭证文件ID（数组）
          fileList: []        // 上传文件列表（每个分组独立）
        }
      ],
      // 下拉数据源
      brands: ['美洲豹', '环球', '毒药', '鬼斧'],
      //品牌数组
      selectOptions: [],
      selectBrandDrop:[],
      dialogVisible: false,
      dialogImageUrl: "",
      captureType: "",
      // 提示弹框组件
      showDialog: false,
      dialogTitle: '提示',
      messageContent: '',
      confirmText: '',
      dialogFlag: '',
      showCancel: false,
      formIndex: 0,
      //select弹框组件
      selectDialogVisible: false,
      selectModelDialogVisible: false,
      currentFormIndex: -1, // 新增：记录当前点击的表单行索引
      // 日期抽屉相关
      dateDrawerVisible: false, // 日期抽屉显示状态
      currentDateRowIndex: -1,  // 当前点击的表单行索引
    }
  },
  created() {
    this.selectBrandDropDown();
  },
  methods: {

    async selectBrandDropDown(){
      try {
        const response = await brandDropDown();
        if(response.code===200){
          this.selectBrandDrop = response.data;
        }
      } catch (error) {
        console.error("获取产品失败:", error);
      }
    },

    // 打开日期抽屉
    openDateDrawer(index) {
      this.currentDateRowIndex = index; // 记录当前行索引
      this.dateDrawerVisible = true;    // 显示抽屉
    },
    // 确认选择日期（绑定到对应行）
    handleDateConfirm(formattedDate) {
      if (this.currentDateRowIndex !== -1) {
        // 赋值到对应行的购买时间
        this.formList[this.currentDateRowIndex].startTime = formattedDate;
      }
      this.dateDrawerVisible = false; // 关闭抽屉
    },
    //打开品牌弹框
    openSelectDialog(index){
      this.currentFormIndex = index; // 记录当前行
      this.selectDialogVisible = true; // 打开弹框

      this.selectOptions = this.selectBrandDrop.map(item=>({
        label: item.value,
        value: item.label
      }));
    },
    //打开型号弹框
    openModelSelectDialog(index){

      if(!this.formList[index].brandCode){
        //提示信息提示弹框组件是否显示
        this.showDialog = true;
        //显示取消按钮
        this.showCancel = false;
        //确认按钮文案
        this.confirmText = "我知道了";
        //提示信息内容
        this.messageContent = "请先选择球杆品牌！";
        return;
      }

      this.currentFormIndex = index; // 记录当前行
      this.selectModelDialogVisible = true; // 打开弹框

      this.selectOptions = this.selectBrandDrop
              .find(parent => parent.label === this.formList[index].brandCode)
              ?.children // 安全地获取其 children 数组
              .map(child => ({ label: child.value, value: child.label })) // 对 children 数组进行 map 转换
          ?? []; // 如果前面任何一步失败(结果为null或undefined)，则返回一个空数组
    },
    handleSelect(item) {
      if (this.currentFormIndex !== -1) {
        this.formList[this.currentFormIndex].brand = item.label; // 赋值到对应行
        this.formList[this.currentFormIndex].brandCode = item.value; // 赋值到对应行
      }
      this.selectDialogVisible = false; // 关闭弹框
    },
    handleSelectModel(item){
      if (this.currentFormIndex !== -1) {
        this.formList[this.currentFormIndex].model = item.label; // 赋值到对应行
        this.formList[this.currentFormIndex].modelCode = item.value; // 赋值到对应行
      }
      this.selectModelDialogVisible = false; // 关闭弹框
    },
    // 新增表单条目
    addFormItem() {
      this.formList.push({
        number: '',
        brand: '',
        model: '',
        startTime: '',
        channel: '',
        price: '',
        proof: [],          // 购买凭证文件ID（数组）
        fileList: []
      });
    },
    //询问框确认事件
    handleDialogConfirm(){
      this.showDialog = false;
      if(this.dialogFlag == 'del'){
        this.formList.splice(this.formIndex, 1);
        this.dialogFlag = "";
      }
    },
    //取消事件
    handleCancel(){
      this.showDialog = false;
      this.dialogFlag = "";
    },
    // 删除表单条目
    deleteFormItem(index) {
      this.dialogFlag = 'del';
      this.formIndex = index;
      //提示信息提示弹框组件是否显示
      this.showDialog = true;
      //显示取消按钮
      this.showCancel = true;
      //确认按钮文案
      this.confirmText = "确定";
      //提示信息内容
      this.messageContent = '确定要删除这条球杆信息吗？';
    },
    // 返回首页
    goHome() {
      // 实际项目可替换为Vue Router跳转：this.$router.push('/')
      this.$router.replace('/sales_home');
    },
    // 图片上传处理
    handleFileChange(file, fileList, index) {
      // 1. 仅处理「文件添加」的场景（status=ready）
      if (file.status !== 'ready') {
        return; // 忽略移除/上传中的状态
      }
      // 2. 校验文件类型（和原before-upload逻辑一致）
      const isImage = file.raw.type.includes("image/"); // 注意：file.raw才是原生File对象
      if (!isImage) {
        //提示信息提示弹框组件是否显示
        this.showDialog = true;
        //显示取消按钮
        this.showCancel = false;
        //确认按钮文案
        this.confirmText = "我知道了";
        //提示信息内容
        this.messageContent = "只能上传jpg/png格式的图片！";
        // 移除错误文件（避免加入fileList）
        this.formList[index].fileList = fileList.filter(item => item.uid !== file.uid);
        return;
      }
      // 3. 生成预览URL并更新fileList（和原逻辑一致）
      const reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = (e) => {
        this.formList[index].fileList = Array.isArray(fileList)
            ? fileList.map(item => {
              if (item.uid === file.uid) {
                return {
                  ...item,
                  url: e.target.result,
                  raw: file.raw
                };
              }
              return item;
            })
            : [];
      };
    },
    // 核心修复4：预览方法重构，确保URL和弹框状态正确
    handlePreview(file, index) {
      this.currentPreviewIndex = index;
      // 优先级：本地预览URL > 响应URL > 原始文件
      if (file.url) {
        this.dialogImageUrl = file.url;
      } else if (file.raw) {
        // 兼容未生成URL的情况，重新生成
        const reader = new FileReader();
        reader.readAsDataURL(file.raw);
        reader.onload = (e) => {
          this.dialogImageUrl = e.target.result;
        };
      } else {
        this.dialogImageUrl = "";
        //提示信息提示弹框组件是否显示
        this.showDialog = true;
        //显示取消按钮
        this.showCancel = false;
        //确认按钮文案
        this.confirmText = "我知道了";
        //提示信息内容
        this.messageContent = "该图片无预览地址！";
      }
      // 强制打开弹框（确保状态更新）
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    },
    // 核心修复5：图片加载失败处理
    handleImageError() {
      this.dialogImageUrl = "";
      //提示信息提示弹框组件是否显示
      this.showDialog = true;
      //显示取消按钮
      this.showCancel = false;
      //确认按钮文案
      this.confirmText = "我知道了";
      //提示信息内容
      this.messageContent = "图片预览失败，请重新上传！";
    },
    // 删除文件（确保列表同步）
    handleRemove(file, fileList, index) {
      this.fileList[index] = [...fileList]; // 深拷贝，避免引用问题
    },
    // 超出数量提示
    handleExceed(index) {
      //提示信息提示弹框组件是否显示
      this.showDialog = true;
      //显示取消按钮
      this.showCancel = false;
      //确认按钮文案
      this.confirmText = "我知道了";
      //提示信息内容
      this.messageContent = `第 ${index + 1} 条球杆最多只能上传3张图片！`;
    },
    // 提交表单
    async handleSubmit() {
      // 1. 优先级1：校验所有球杆编号是否填写（trim后非空）
      const emptyNumberIndex = this.formList.findIndex(item => !item.number.trim());
      if (emptyNumberIndex !== -1) {
        this.showDialog = true;
        this.showCancel = false;
        this.confirmText = "我知道了";
        this.messageContent = `第 ${emptyNumberIndex + 1} 条球杆编号不能为空，请填写！`;
        return;
      }
      // 2. 优先级2：校验编号是否重复（此时numberList已无空值）
      const numberList = this.formList.map(item => item.number.trim());
      const hasDuplicateNumber = new Set(numberList).size !== numberList.length;
      if (hasDuplicateNumber) {
        this.showDialog = true;
        this.showCancel = false;
        this.confirmText = "我知道了";
        this.messageContent = "球杆编号不能重复，请修改！";
        return;
      }
      // 3. 优先级3：校验其他必填项 + 文件
      let valid = true;
      this.formList.forEach((form) => {
        if (valid) {
          // 编号已校验过，此处校验其他必填项
          const requiredFields = ["brand", "model", "channel", "price", "startTime"];
          const hasEmpty = requiredFields.some(field => !form[field].trim());
          const hasFile = Array.isArray(form.fileList) && form.fileList.length > 0;
          if (hasEmpty) {
            valid = false;
            this.showDialog = true;
            this.showCancel = false;
            this.confirmText = "我知道了";
            this.messageContent = `球杆【${form.number}】存在未填写的必填项（品牌/型号/渠道/价格/时间）！`;
          } else if (!hasFile) {
            valid = false;
            this.showDialog = true;
            this.showCancel = false;
            this.confirmText = "我知道了";
            this.messageContent = `球杆【${form.number}】未上传购买凭证！`;
          }
        }
      });
      if (!valid) return;

      // 2. 构造符合后端要求的FormData
      const formData = new FormData();
      // 2.1 传递球杆信息列表（对应后端的List<Product> productlist）
      this.formList.forEach((item, index) => {
        // 格式：productList[索引].属性名
        formData.append(`productList[${index}].number`, item.number); // 球杆编号
        formData.append(`productList[${index}].brand`, item.brand); // 品牌
        formData.append(`productList[${index}].model`, item.model); // 型号
        formData.append(`productList[${index}].brandCode`, item.brandCode); // 品牌
        formData.append(`productList[${index}].modelCode`, item.modelCode); // 型号
        formData.append(`productList[${index}].channel`, item.channel); // 购买渠道（值）
        formData.append(`productList[${index}].price`, item.price); // 价格
        formData.append(`productList[${index}].startTime`, item.startTime); // 购买时间
      });
      this.formList.forEach((item) => {
        const fileList = item.fileList; // 关键修改4：正确获取当前表单项的文件列表
        const key = item.number.trim();
        if (Array.isArray(fileList) && fileList.length > 0) {
          fileList.forEach(file => {
            if (file.raw) { // 确保原生文件对象存在
              formData.append(key, file.raw);
            }
          });
        }
      });
      const res = await relation(formData)
      if (res.code === 200) {
        this.showDialog = true;
        this.showCancel = false;
        this.confirmText = "我知道了";
        this.messageContent = res.returnMsg;
      } else {
        this.showDialog = true;
        this.showCancel = false;
        this.confirmText = "我知道了";
        this.messageContent = res.returnMsg;
      }
    }
  }
}
</script>

<style lang="scss">
.container{
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: #efefef;

  // 通用样式：所有设备共享（单列布局核心）
  .form-container {
    padding: 10px 0;
    max-width: 1200px;
    margin: 0 auto; // 整体居中
  }

  .form-item-wrapper {
    background: #fff;
    border-radius: 8px;
    padding: 15px 0;
    margin: 0 15px 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }

  .form-item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding: 0 30px 10px;
    border-bottom: 1px solid #f5f5f5;

    span {
      font-size: 20px;
      font-weight: 600;
    }

    .delete-btn {
      color: #e53935;
      font-size: 18px;
    }
  }

  .add-form-btn {
    display: block;
    width: 90%;
    margin: 10px auto;
    border: 1px dashed #409eff;
    color: #409eff;
  }

  // 表单基础样式（单列）
  .form-inline {
    padding: 0 30px;
  }

  .el-form-item {
    background: #FFFFFF;
    height: auto;
    padding: 0 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .el-form-item__label {
    font-weight: 500;
    text-align: left !important;
    line-height: normal;
  }

  .el-form-item__content {
    flex: 1;
    line-height: normal;
    padding-left: 10px;
  }

  // 输入框/日期输入框通用样式
  .el-input__inner,
  .uni-date-input {
    width: 100%;
    border: none;
    outline: none;
    background: #fff;
    color: #333;
    box-sizing: border-box;
  }

  .uni-date-input::placeholder {
    color: #c0c4cc;
  }

  .upload-tip {
    font-size: 12px;
    color: #999;
    margin-top: 5px;
  }

  .title {
    text-align: center;
    line-height: 60px;
    font-size: 18px;
    color: #161616;
    letter-spacing: 1px;
    background: #f6c27a;
    font-weight: bold;
  }

  .input {
    height: 50px;
    background: #FFFFFF;
    padding: 5px 0;
  }

  .s-footer {
    height: 50px;
    background: #2c2c2c;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      color: #ea9538;
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 1px;
    }
  }

  .btn-group,
  .btn-group-back {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin: 20px 0;
  }

  .el-button {
    border-radius: 3px;
  }

  // 上传组件通用样式（单列）
  .avatar-uploader {
    .el-upload--picture-card {
      position: relative;
    }
  }

  .el-upload-list--picture-card {
    .el-upload-list__item {
      position: relative;
      margin-right: 10px;
      margin-bottom: 10px;
    }

    .el-upload-list__item-thumbnail {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .el-upload-list__item-delete,
    .el-upload-list__item-preview {
      border-radius: 50%;
      background: rgba(0,0,0,0.5);
      color: #fff !important;
      text-align: center;
    }

    .el-upload-list__item:hover .el-upload-list__item-delete,
    .el-upload-list__item:hover .el-upload-list__item-preview {
      background: rgba(0,0,0,0.7);
    }
  }

  // 预览弹框空状态
  .preview-empty {
    text-align: center;
    padding: 20px;
    color: #999;
    font-size: 14px;
  }

  /* -------------------------- 移动端适配 (<=768px) -------------------------- */
  @media screen and (max-width: 768px) {
    .form-container{
      max-width: 768px;
    }
    .form-item-header {
      span {
        font-size: 16px;
      }
      .delete-btn {
        font-size: 14px;
        &:hover {
          color: #e53935;
          text-decoration: underline;
        }
      }
    }
    .uni-date-input {
      font-size: 16px;
    }

    .el-button--primary{
      font-size: 20px;
      color: #0f0f0f;
      background: #f6c27a;
      border: none;
      width: 80%;
      border-radius: 3px;
    }

    .el-button--default{
      font-size: 20px;
      color: #0f0f0f;
      background: #dcdcdc;
      border: none;
      width: 80%;
      border-radius: 3px;
    }


    .el-form-item {
      background: #FFFFFF;
      height: auto; // 修复原固定高度导致的内容溢出
      padding: 0 10px;
      //margin-bottom: 5px; // 增加表单项间距
    }

    /* 1. 修改Label样式：字体大小、宽度、对齐方式 */
    .el-form-item__label {
      font-weight: 500;
      font-size: 16px !important; /* Label字体大小（默认14px） */
      text-align: left !important;
      line-height: 50px;
    }

    /* 2. 修改输入框/下拉框/日期选择器 样式 */
    /* 统一控件高度和字体大小 */
    .el-input__inner,
    .el-select-dropdown__item,
    .el-date-picker__header,
    .el-date-picker__cell {
      font-size: 16px !important;  /* 控件内文本大小（默认14px） */
      height: 50px !important;     /* 控件高度（默认36px） */
      line-height: 50px !important;/* 行高与高度一致，垂直居中 */
      border: none;
    }

    .upload-tip {
      font-size: 10px;
      color: #999;
      margin-top: 5px;
    }

    .title {
      text-align: center;
      line-height: 60px;
      font-size: 16px;
      color: #161616;
      letter-spacing: 1px;
      background: #f6c27a;
      font-weight: bold;
    }
    .input{
      height: 50px;
      background: #FFFFFF;
      padding: 5px 0;
    }
    .s-footer{
      height: 50px;
      background: #2c2c2c;
      display: flex;
      justify-content: center; /* 水平居中（主轴对齐） */
      align-items: center;     /* 垂直居中（交叉轴对齐） */
      p{
        color: #ea9538;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 1px;
      }
    }
    .btn-group {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-top: 20px;
      height: 50px;
      line-height: 50px;
      font-size: 26px;
    }
    .btn-group-back {
      display: flex;
      justify-content: center;
      gap: 15px;
      height: 50px;
      line-height: 50px;
      margin: 20px 0 20px 0;
    }

    /* -------------------------- 核心修改：统一预览/删除按钮样式 -------------------------- */
    // 上传卡片/缩略图基础样式
    .avatar-uploader {
      .el-upload--picture-card {
        width: 100px !important;
        height: 100px !important;
        line-height: 100px !important;
        font-size: 20px !important;
      }
    }
    .el-upload-list--picture-card {
      .el-upload-list__item {
        width: 100px !important;
        height: 100px !important;
        margin-right: 10px !important;
        margin-bottom: 10px !important;
        position: relative; // 确保子元素绝对定位生效
      }
      // 已上传图片预览图适配
      .el-upload-list__item-thumbnail {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      // 1. 删除按钮样式（基准）
      .el-upload-list__item-delete {
        font-size: 16px !important; // 按钮大小
        top: 5px !important;        // 垂直位置
        right: 5px !important;      // 水平位置
        width: 20px !important;     // 点击区域大小
        height: 20px !important;
        line-height: 20px !important;
        border-radius: 50%; // 圆形背景（可选，和预览按钮统一）
        background: rgba(0,0,0,0.5); // 半透明背景
        color: #fff !important;
        text-align: center;
      }

      // 2. 预览按钮样式（和删除按钮完全统一）
      .el-upload-list__item-preview {
        font-size: 16px !important; // 和删除按钮同大小
        top: 5px !important;        // 和删除按钮同垂直位置
        right: 30px !important;     // 位于删除按钮左侧，间距合理
        width: 20px !important;     // 点击区域和删除按钮一致
        height: 20px !important;
        line-height: 20px !important;
        border-radius: 50%; // 圆形背景，和删除按钮统一
        background: rgba(0,0,0,0.5); // 半透明背景
        color: #fff !important;
        text-align: center;
        // 预览图标居中
        .el-icon-zoom-in {
          font-size: 14px !important; // 图标略小于按钮，视觉更协调
          line-height: 20px !important;
        }
      }

      // 鼠标悬浮效果（可选，增强交互）
      .el-upload-list__item:hover .el-upload-list__item-delete,
      .el-upload-list__item:hover .el-upload-list__item-preview {
        background: rgba(0,0,0,0.7);
      }
    }

    // 预览弹框空状态样式
    .preview-empty {
      text-align: center;
      padding: 20px;
      color: #999;
      font-size: 14px;
    }

  }

  /* -------------------------- 平板适配 (769px ~ 1024px) -------------------------- */
  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .form-container {
      padding: 20px 0;
    }

    .form-item-wrapper {
      margin: 0 20px 20px;
      padding: 20px 0;
    }

    .form-item-header {
      padding: 0 40px 15px;
      span {
        font-size: 22px;
      }
      .delete-btn {
        font-size: 19px;
        &:hover {
          color: #e53935;
          text-decoration: underline;
        }
      }
    }

    .form-inline {
      padding: 0 40px;
    }

    .el-form-item {
      padding: 10px;
      border-radius: 4px;
      margin-bottom: 15px;
    }

    .el-form-item__label {
      font-size: 16px !important;
      width: 100px !important;
      line-height: 40px;
    }

    .el-input__inner {
      font-size: 16px !important;
      height: 40px !important;
      line-height: 40px !important;
      border: 1px solid #e4e7ed !important;
      border-radius: 4px;
    }

    .uni-date-input {
      font-size: 16px !important;
      height: 40px !important;
      line-height: 40px !important;
      border: 1px solid #e4e7ed !important;
      border-radius: 4px;
      padding: 0 10px;
    }

    .upload-tip {
      font-size: 13px;
      margin-top: 10px;
    }

    .title {
      font-size: 20px;
      line-height: 70px;
    }

    .s-footer p {
      font-size: 13px;
    }

    .el-button--primary,
    .el-button--default {
      font-size: 18px;
      padding: 10px 30px;
      min-width: 500px;
    }

    .el-button--primary {
      background: #f6c27a;
      border: none;
    }

    .el-button--default {
      background: #dcdcdc;
      color: #666;
      border: 1px solid #e4e7ed;
    }

    // 平板上传组件
    .avatar-uploader .el-upload--picture-card {
      width: 120px !important;
      height: 120px !important;
      line-height: 120px !important;
      font-size: 24px !important;
    }

    .el-upload-list--picture-card .el-upload-list__item {
      width: 120px !important;
      height: 120px !important;
    }

    .el-upload-list__item-delete {
      font-size: 18px !important;
      top: 8px !important;
      right: 8px !important;
      width: 24px !important;
      height: 24px !important;
      line-height: 24px !important;
    }

    .el-upload-list__item-preview {
      font-size: 18px !important;
      top: 8px !important;
      right: 40px !important;
      width: 24px !important;
      height: 24px !important;
      line-height: 24px !important;
      .el-icon-zoom-in {
        font-size: 16px !important;
        line-height: 24px !important;
      }
    }
  }

  /* -------------------------- PC端适配 (>1024px) -------------------------- */
  @media screen and (min-width: 1025px) {

    .form-item-wrapper {
      margin: 0 auto 30px;
      padding: 25px 0;
      max-width: 900px; // 单列固定宽度，居中显示
    }

    .form-item-header {
      padding: 0 50px 20px;
      span {
        font-size: 24px;
      }
      .delete-btn {
        font-size: 20px;
        &:hover {
          color: #e53935;
          text-decoration: underline;
        }
      }
    }

    .form-inline {
      padding: 0 50px;
    }

    .el-form-item {
      padding: 12px;
      border-radius: 6px;
      box-shadow: 0 1px 3px rgba(0,0,0,0.03);
      margin-bottom: 20px;
      transition: box-shadow 0.2s;
      &:hover {
        box-shadow: 0 2px 8px rgba(0,0,0,0.08);
      }
    }

    .el-form-item__label {
      font-size: 17px !important;
      width: 110px !important;
      line-height: 44px;
      color: #222;
    }

    .el-input__inner {
      font-size: 17px !important;
      height: 44px !important;
      line-height: 44px !important;
      border: 1px solid #e4e7ed !important;
      border-radius: 4px;
      padding: 0 12px;
      &:focus {
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
      }
    }

    .uni-date-input {
      font-size: 17px !important;
      height: 44px !important;
      line-height: 44px !important;
      border: 1px solid #e4e7ed !important;
      border-radius: 4px;
      padding: 0 12px;
      &:focus {
        outline: none;
        border-color: #409eff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
      }
    }

    .upload-tip {
      font-size: 14px;
      margin-top: 8px;
    }

    .title {
      font-size: 22px;
      line-height: 80px;
      background: #f8b768;
    }

    .s-footer {
      height: 60px;
      p {
        font-size: 14px;
        letter-spacing: 2px;
      }
    }

    .btn-group,
    .btn-group-back {
      gap: 30px;
      margin: 30px 0;
    }

    .el-button--primary {
      font-size: 18px;
      color: #333;
      background: #f8b768;
      border: none;
      padding: 12px 20px;
      border-radius: 4px;
      min-width: 600px;
    }

    .el-button--default {
      font-size: 18px;
      color: #333;
      background: #dcdcdc;
      border: 1px solid #e4e7ed;
      padding: 12px 20px;
      border-radius: 4px;
      min-width: 600px;
    }

    // PC端上传组件
    .avatar-uploader .el-upload--picture-card {
      width: 140px !important;
      height: 140px !important;
      line-height: 140px !important;
      font-size: 28px !important;
      border-radius: 6px;
      transition: all 0.2s;
      &:hover {
        transform: scale(1.03);
        box-shadow: 0 4px 16px rgba(0,0,0,0.08);
      }
    }

    .el-upload-list--picture-card .el-upload-list__item {
      width: 140px !important;
      height: 140px !important;
      border-radius: 6px;
      overflow: hidden;
      transition: transform 0.2s;
      &:hover {
        transform: scale(1.03);
      }
    }

    .el-upload-list__item-delete {
      font-size: 20px !important;
      top: 10px !important;
      right: 10px !important;
      width: 28px !important;
      height: 28px !important;
      line-height: 28px !important;
      &:hover {
        background: #f56c6c;
      }
    }

    .el-upload-list__item-preview {
      font-size: 20px !important;
      top: 10px !important;
      right: 50px !important;
      width: 28px !important;
      height: 28px !important;
      line-height: 28px !important;
      &:hover {
        background: #409eff;
      }
      .el-icon-zoom-in {
        font-size: 18px !important;
        line-height: 28px !important;
      }
    }
  }
}
</style>